export const mutations = {
  setSentRequestStatuses(state, sentRequestStatuses) {
    state.sentRequestStatuses = sentRequestStatuses;
  },
};
